import axios from 'axios';
import { BASE_URL } from '../api';
const http=axios.create({baseURL:BASE_URL,headers:{'Content-Type':'application/json'}});
const ROOT='/tasks/drawer/';
const guestMemory=new Map();
export function errorText(error) {
 const data=error.response?.data;if(Array.isArray(data))return data.filter(value=>typeof value==='string').join(' ').slice(0,500)||error.message;return typeof data==='string'?data.slice(0,200):typeof data?.detail==='string'?data.detail:typeof data?.error==='string'?data.error:error.message||'Не удалось выполнить действие.';
}
export function sessionKey(link) {return `lunadesk.drawer.guest.v1.${link}`;}
export function rememberGuest(link,session) {guestMemory.set(link,session);try{localStorage.setItem(sessionKey(link),session)}catch{/* Storage may be unavailable; the open page keeps its session. */}}
export function auth(link) {
 let jwt,session=guestMemory.get(link);try{jwt=localStorage.getItem('auth_token');session=(link&&localStorage.getItem(sessionKey(link)))||session;}catch{/* Optional storage. */}
 return link&&session?(jwt?`DrawerAccount ${jwt}~${session}`:`Drawer ${session}`):jwt?`Bearer ${jwt}`:'';
}
export function client(boardId,link) {
 const prefix=link?`${ROOT}shared/${link}/`:`${ROOT}boards/${boardId}/`;
 const config=()=>({headers:{Authorization:auth(link)}});
 return {
  load:since=>http.get(prefix+(link?'state/':''),{...config(),params:since===undefined?undefined:{since}}).then(r=>r.data),
  save:operations=>http.post(prefix+'operations/',{operations},config()).then(r=>r.data),
  people:state=>http.post(prefix+'people/',state,config()).then(r=>r.data),
  asset:id=>http.get(prefix+`assets/${id}/`,{...config(),responseType:'blob'}).then(r=>r.data),
  upload:data=>http.post(prefix+'assets/',{data},config()).then(r=>r.data),
  metadata:patch=>http.patch(prefix,patch,config()).then(r=>r.data),
  links:()=>http.get(prefix+'links/',config()).then(r=>r.data.links),
  createLink:data=>http.post(prefix+'links/',data,config()).then(r=>r.data),
  revoke:id=>http.patch(prefix+`links/${id}/`,{revoked:true},config()),
  changeLink:(id,scope)=>http.patch(prefix+`links/${id}/`,{scope},config()),
  participants:()=>http.get(prefix+'participants/',config()).then(r=>r.data.participants),
  kick:id=>http.delete(prefix+`participants/${id}/`,config()),
 };
}
export const listBoards=()=>http.get(ROOT+'boards/',{headers:{Authorization:auth()}}).then(r=>r.data.boards);
export const createBoard=(title,settings={})=>http.post(ROOT+'boards/',{title,settings},{headers:{Authorization:auth()}}).then(r=>r.data);
export const removeBoard=id=>http.delete(ROOT+`boards/${id}/`,{headers:{Authorization:auth()}});
export const publicInfo=link=>http.get(ROOT+`shared/${link}/`).then(r=>r.data);
export async function join(link,name) {
 const response=await http.post(ROOT+`shared/${link}/join/`,{name},{headers:{Authorization:auth(link)}});
 if(response.data.session)rememberGuest(link,response.data.session);
 return response.data;
}
export function clearGuest(link){guestMemory.delete(link);try{localStorage.removeItem(sessionKey(link))}catch{/* Optional storage. */}}
export const socketURL=id=>`${BASE_URL.replace(/^http/,'ws')}/ws/drawer/${id}/`;
